import React, { Component } from "react";
import * as icons from "common/icons";
import { compose, withAppContext } from "containers/HOC";

class Watermark extends Component {
    render() {
        const { refData = {} } = this.props;
        const { deploymentType = "Commercial" } = refData;
        return deploymentType === "Commercial" ? null : <div className="Watermark u-pos-rel u-overflow-hidden" style={{ backgroundImage: `url(${icons.logoPrint()})` }} />;
    }
}

export default compose(withAppContext)(Watermark);
